import { useEffect, useState } from 'react';

/**
 * A hook that debounces `value`.
 *
 * If you need to debounce a callback, use `lodash.debounce` instead.
 * @param {T} value The value to debounce.
 * @param {number} delay The number of milliseconds to delay.
 * @returns {T} The debounced value.
 */
const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebouncedValue(value), delay || 500);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
